module.exports = __webpack_public_path__ + "img/s2.93707dd8.png";